import { useTranslation } from 'next-i18next';
import { BoltFillColorMintIcon, BoltFillColorVioletIcon } from '@/icons';
import { Chip } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
import { type SectionKey } from '../constants';
interface SectionNavBarProps {
  sectionKeys: SectionKey[];
}
export const SectionNavBar = ({
  sectionKeys
}: SectionNavBarProps) => {
  const {
    t
  } = useTranslation(['build']);
  const BADGE_NAMES: Record<SectionKey, string> = {
    NEW: t('build:mapTemplate.recommended'),
    FREE: t('build:mapTemplate.free'),
    BASIC: 'Basic',
    PRO: 'Pro'
  };
  const handleClickBadge = (sectionKey: SectionKey) => {
    const element = document.getElementById(`section-${sectionKey}`);
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <nav className="sticky top-0 z-[25] flex shrink-0 gap-2xs overflow-x-auto bg-[linear-gradient(180deg,#F5F6F9_79.81%,rgba(245,246,249,0.00)_100%)] pb-sm" data-sentry-component="SectionNavBar" data-sentry-source-file="SectionNavBar.tsx">
      {sectionKeys.map(sectionKey => <Chip key={sectionKey} className={cn('shrink-0 cursor-pointer border border-alternative bg-white text-neutral hover:shadow-sm')} size="lg" leftSlot={(() => {
      if (sectionKey === 'BASIC') {
        return <BoltFillColorMintIcon size="xs" />;
      }
      if (sectionKey === 'PRO') {
        return <BoltFillColorVioletIcon size="xs" />;
      }
      return undefined;
    })()} onClick={() => handleClickBadge(sectionKey)}>
          {BADGE_NAMES[sectionKey]}
        </Chip>)}
    </nav>;
};